var now = Date.now || function () {
  return new Date().getTime();
};
export default now;